<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="departments" :hide-actions="true" item-key="code" no-data-text="Список кафедр пуст">
          <template v-slot:items="props">
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.title[locale] }}</td>
            <td>{{ props.item.abbreviation[locale] }}</td>
            <td>{{ props.item.institution[locale] }}</td>
            <td>{{ props.item.head }}</td>
            <td class="text-xs-right layout">
              <v-btn flat icon title="Редактировать" color="primary">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn flat icon title="Удалить" color="error">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout mt-3>
      <v-flex xs12 text-xs-right>
        <v-dialog v-model="departmentForm.dialog" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="info" v-on="on">Добавить</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Новая кафедра</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="departmentForm.valid" ref="departmentForm">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select label="Институт" required v-model="departmentForm.values.institution" :items="institutions" item-value="code" item-text="title" :rules="departmentForm.rules.institution"></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Название кафедры" required v-model="departmentForm.values.title" :counter="255" :rules="departmentForm.rules.title" />
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field label="Аббревиатура" required v-model="departmentForm.values.abbreviation" :counter="20" :rules="departmentForm.rules.abbreviation" />
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field label="Код" required v-model="departmentForm.values.code" :counter="20" :rules="departmentForm.rules.code" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="departmentFormClose">Отмена</v-btn>
              <v-btn color="blue darken-1" flat @click="departmentFormSave" :loading="departmentForm.saving">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    departmentForm: {
      dialog: false,
      valid: false,
      saving: false,
      values: {
        code: '',
        institution: '',
        title: '',
        abbreviation: ''
      },
      rules: {
        code: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 20) || 'Максимум 20 символов'
        ],
        institution: [
          v => !!v || 'Необходимо указать институт'
        ],
        title: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 255) || 'Максимум 255 символов'
        ],
        abbreviation: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 20) || 'Максимум 20 символов'
        ]
      }
    },
    headers: [
      {
        text: 'Код',
        align: 'left',
        sortable: true,
        value: 'code'
      },
      {
        text: 'Название кафедры',
        align: 'left',
        sortable: true,
        value: 'title'
      },
      {
        text: 'Аббревиатура',
        align: 'left',
        sortable: true,
        value: 'abbreviation'
      },
      {
        text: 'Институт',
        align: 'left',
        sortable: true,
        value: 'institution'
      },
      {
        text: 'Заведующий',
        align: 'left',
        sortable: true,
        value: 'head'
      },
      {
        text: '',
        value: null
      }
    ]
  }),
  computed: {
    ...mapState('institutions', {
      institutions: (state) => {
        return Object.values(state.institutions).sort((a, b) => {
          if (a.title < b.title) return -1
          if (a.title > b.title) return 1
          return 0
        })
      },
    }),
    ...mapState('departments', {
      departments: (state) => {
        return Object.values(state.departments).sort((a, b) => {
          if (a.title < b.title) return -1
          if (a.title > b.title) return 1
          return 0
        })
      }
    }),
    locale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    this.loadInstitutions()
    this.loadDepartments()
  },
  methods: {
    loadInstitutions () {
      this.$store.dispatch('institutions/getInstitutions').catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },
    loadDepartments () {
      this.$store.dispatch('departments/getDepartments').catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },

    departmentFormOpen (department) {
      this.departmentForm.values = department
      this.departmentForm.dialog = true
    },
    departmentFormClose () {
      this.departmentForm.dialog = false
      this.$refs.departmentForm.reset()
    },
    departmentFormSave () {
      if (this.$refs.departmentForm.validate()) {
        this.departmentForm.saving = true
        this.$store.dispatch('departments/saveDepartment', this.departmentForm.values).then(() => {
          this.$events.$emit('notify', {
            message: 'Кафедра успешно добавлена',
            type: 'info'
          })
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        }).finally(() => {
          this.departmentForm.saving = false
          this.departmentFormClose()
        })
      }
    }
  },
}
</script>
